module.exports = __webpack_public_path__ + "static/media/facepalm.7799bdc1.png";